<template>
  <div :class="`TRL-explainer ${active ? 'TRL-explainer--open' : ''}`">
    <span class="icon icon--close-btn TRL-explainer__close" @click="close">
      <svg>
        <title>Close explanation</title>
        <use xlink:href="#icon--close-btn"></use>
      </svg>
    </span>
    <h3>Technology Readiness Levels (TRLs)</h3>

    <div class="TRL-explainer__stage TRL-explainer__stage--1">
      <span class="TRL-explainer__stage-title"> Concept </span>
      <div
        v-for="(TRL, index) in TRLs.filter((TRL) => TRL.stage === 'Concept')"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="TRL-explainer__stage TRL-explainer__stage--2"
      :style="{ borderStyle: 'none none solid none' }"
    >
      <span class="TRL-explainer__stage-title"> Small prototype </span>
      <div
        v-for="(TRL, index) in TRLs.filter(
          (TRL) => TRL.stage === 'Small prototype'
        )"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
      <!-- <span class="TRL-explainer__beyond-SDS">Beyond the SDS 🡅</span> -->
    </div>
    <div class="TRL-explainer__stage TRL-explainer__stage--3">
      <span class="TRL-explainer__stage-title"> Large prototype </span>
      <!-- <span class="TRL-explainer__SDS">Scope of the SDS 🡇</span> -->
      <div
        v-for="(TRL, index) in TRLs.filter(
          (TRL) => TRL.stage === 'Large prototype'
        )"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
    </div>
    <div class="TRL-explainer__stage TRL-explainer__stage--4">
      <span class="TRL-explainer__stage-title"> Demonstration </span>
      <div
        v-for="(TRL, index) in TRLs.filter(
          (TRL) => TRL.stage === 'Demonstration'
        )"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
    </div>
    <div class="TRL-explainer__stage TRL-explainer__stage--5">
      <span class="TRL-explainer__stage-title"> Early adoption </span>
      <div
        v-for="(TRL, index) in TRLs.filter(
          (TRL) => TRL.stage === 'Early adoption'
        )"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
    </div>
    <div class="TRL-explainer__stage TRL-explainer__stage--6">
      <span class="TRL-explainer__stage-title"> Mature </span>
      <div
        v-for="(TRL, index) in TRLs.filter((TRL) => TRL.stage === 'Mature')"
        :key="`TRLlegend${index}`"
        class="TRL-explainer__row"
      >
        <div :class="`TRL-explainer__TRL tech-table__trl--${TRL.level}`">
          <span>{{ TRL.level }}</span>
        </div>
        <div class="TRL-explainer__info-box">
          <span class="TRL-explainer__info-title">{{ TRL.title }}</span>
          <span class="TRL-explainer__info-description">{{
            TRL.description
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      TRLs: [
        {
          level: 1,
          title: "Initial idea",
          description: "Basic principles have been defined",
          stage: "Concept",
        },
        {
          level: 2,
          title: "Application formulated",
          description:
            "Concept and application of solution have been formulated",
          stage: "Concept",
        },
        {
          level: 3,
          title: "Concept needs validation",
          description: "Solution needs to be prototyped and applied",
          stage: "Concept",
        },
        {
          level: 4,
          title: "Early prototype",
          description: "Prototype proven in test conditions",
          stage: "Small prototype",
        },
        {
          level: 5,
          title: "Large prototype",
          description: "Components proven in conditions to be deployed",
          stage: "Large prototype",
        },
        {
          level: 6,
          title: "Full prototype at scale",
          description: "Prototype proven at scale in conditions to be deployed",
          stage: "Large prototype",
        },
        {
          level: 7,
          title: "Pre-commercial demonstration",
          description: "Prototype working in expected conditions",
          stage: "Demonstration",
        },
        {
          level: 8,
          title: "First of a kind commercial",
          description:
            "Commercial demonstration, full-scale deployment in final conditions",
          stage: "Demonstration",
        },
        {
          level: 9,
          title: "Commercial operation in relevant environment",
          description:
            "Solution is commercially available, needs evolutionary improvement to stay competitive",
          stage: "Early adoption",
        },
        {
          level: 10,
          title: "Integration needed at scale",
          description:
            "Solution is commercial and competitive but needs further integration efforts",
          stage: "Early adoption",
        },
        {
          level: 11,
          title: "Proof of stability reached",
          description: "Predictable growth",
          stage: "Mature",
        },
      ],
    };
  },
};
</script>

<style>
/*
* TRL Explainer
*/
.TRL-explainer.TRL-explainer--open {
  right: 0%;
  transition: right 300ms;
}
.TRL-explainer {
  position: fixed;
  top: 10%;
  z-index: 999;
  right: -125%;
  font-size: 14px;
  padding: 1em 0.5em 1em 2.5em;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: right 300ms;
}
.TRL-explainer__SDS {
  position: absolute;
  top: 1em;
  right: 1em;
  font-size: 1.5em;
  opacity: 0.5;
}
.TRL-explainer__beyond-SDS {
  position: absolute;
  right: 1em;
  bottom: 1em;
  font-size: 1.5em;
  opacity: 0.5;
}
.TRL-explainer__close {
  position: absolute;
  top: 2em;
  right: 2em;
  cursor: pointer;
}
.TRL-explainer__stage {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 0.5em;
  padding-top: 1em;
  border-bottom: 2px dashed #e6e6e6;
}
.TRL-explainer__stage:last-child {
  border-bottom: none;
}
.TRL-explainer__stage-title {
  width: max-content;
  flex: 0 0 auto;
  font-weight: bold;
  font-size: 1em;
  padding: 0.25em 0.5em;
  margin-bottom: 0.5em;
}
.TRL-explainer__stage--1 .TRL-explainer__stage-title {
  background: #c9abf4;
}
.TRL-explainer__stage--2 .TRL-explainer__stage-title {
  background: #ff9683;
}
.TRL-explainer__stage--3 .TRL-explainer__stage-title {
  background: #ffcd7c;
}
.TRL-explainer__stage--4 .TRL-explainer__stage-title {
  background: #fff78c;
}
.TRL-explainer__stage--5 .TRL-explainer__stage-title {
  background: #96f7b4;
}
.TRL-explainer__stage--6 .TRL-explainer__stage-title {
  background: #80e0ff;
}
.TRL-explainer__row {
  display: flex;
  margin-bottom: 0.5em;
}
.TRL-explainer__TRL {
  position: relative;
  display: block;
  width: 5em;
  margin-right: 1em;
}
.TRL-explainer__TRL span {
  font-size: 1.5em;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.TRL-explainer__info-box {
  flex: 1 0 auto;
  line-height: 1.25;
}
.TRL-explainer__info-title {
  display: block;
  font-size: 1em;
}
.TRL-explainer__info-description {
  display: block;
  font-size: 0.8em;
}
@media screen and (max-width: 1024px) {
  .TRL-explainer {
    top: 0;
    font-size: 12px;
  }
  .TRL-explainer h3 {
    font-size: 1.25em;
    margin-bottom: 0;
  }
  .TRL-explainer__TRL span {
    font-size: 1.1em;
  }
  .TRL-explainer__stage-title {
    font-size: 1em;
  }
}
@media screen and (max-height: 900px) {
  .TRL-explainer {
    top: 0;
  }
}
@media screen and (max-height: 825px) {
  .TRL-explainer__stage-title {
    display: none;
  }
}
@media screen and (max-height: 600px) {
  .TRL-explainer,
  .TRL-explainer__expand {
    display: none !important;
  }
  .tech-table__trl {
    cursor: default;
  }
}
</style>
